export const NEWLINES_REGEX = /(\r\n\t|\n|\r\t)/g;
